import { render, staticRenderFns } from "./messengers-stuff.vue?vue&type=template&id=d498ce5c&"
import script from "./messengers-stuff.vue?vue&type=script&lang=ts&"
export * from "./messengers-stuff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports